import { GripVertical } from "lucide-react";
import { Box } from "@radix-ui/themes";
import { forwardRef } from "react";

interface DragHandleProps extends React.HTMLAttributes<HTMLDivElement> {
  disabled?: boolean;
}

const DragHandle = forwardRef<HTMLDivElement, DragHandleProps>(
  ({ disabled, ...props }, ref) => {
    if (disabled) return null;

    return (
      <Box
        ref={ref}
        {...props}
        style={{
          padding: "var(--space-2)",
          borderRadius: "var(--radius-2)",
          cursor: "grab",
          display: "flex",
          alignItems: "center",
          ...props.style,
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = "var(--gray-a3)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = "transparent";
        }}
      >
        <GripVertical
          style={{ width: "16px", height: "16px", color: "var(--gray-9)" }}
        />
      </Box>
    );
  },
);

DragHandle.displayName = "DragHandle";
export default DragHandle;
